import { CreatedMenu, DeletedItemMenu, LinkedItemMenu, OperinMenu, OperoutMenu, PickedUpMenu, ReadyForDeliveryMenu, StatusItemMenu } from '@/components/Menu/OrderMenu'
import { Dropdown } from 'react-bootstrap'
import { OrderType } from '@/types/OrderType'

type OrderDropMenuProps = {
  order: OrderType
  handleUpdateStatus: (id_order: number, status: string) => void
  handleSendNotification: (id_order: number, status: string) => void
  handleDelete: (id_order: number) => void
}

export default function OrderDropMenu({order, handleUpdateStatus, handleSendNotification, handleDelete}: OrderDropMenuProps)  {
    return (
      <Dropdown>
        <Dropdown.Toggle variant='secondary' id='dropdown-basic' as='div' className='no-arrow'>
          <i className='ri-more-2-fill ri-xl'></i>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <LinkedItemMenu
            orderId={order?.id}
            url={'/livraisons/detail/'}
            label='Afficher le détail'
            icon='ri-list-check-2'
          />
          {order?.status === 'picked_up' ? (
            <PickedUpMenu orderId={order?.id} handleUpdateStatus={handleUpdateStatus} />
          ) : null}
          {order?.status === 'ready_for_delivery' ? (
            <ReadyForDeliveryMenu
              orderId={order?.id}
              handleUpdateStatus={handleUpdateStatus}
            />
          ) : null}
          {order?.status === 'created' && (
            <CreatedMenu orderId={order?.id} handleUpdateStatus={handleUpdateStatus} />
          )}
          {order?.status === 'operout' && (
            <OperoutMenu orderId={order?.id} handleUpdateStatus={handleSendNotification} />
          )}
          
          {order?.status === 'operin' ||
          order?.status === 'reminder' ||
          order?.status === 'overtimedue' ||
          order?.status === 'overtime' ? (
            <>
             <OperinMenu orderId={order?.id} handleSendNotification={handleSendNotification} />
              <StatusItemMenu
                orderId={order?.id}
                handleUpdateStatus={handleUpdateStatus}
                status={'operout'}
                icon='ri-logout-box-line'
                label='Commande récupérée par le coursier'
              />
              
            </>
          ) : null}
          {order?.status === 'operin' ||
          order?.status === 'reminder' ||
          order?.status === 'overtimedue' ||
          order?.status === 'left_for_customer_service' ||
          order?.status === 'overtime' ? (
            <StatusItemMenu
              orderId={order?.id}
              handleUpdateStatus={handleUpdateStatus}
              status={'receive'}
              icon='ri-checkbox-line'
              label='Commande récupérée par le client'
            />
          ) : null}
          {order?.status === 'created' ||
          order?.status === 'left_for_customer_service' ||
          order?.status === 'ready_for_delivery' ? (
            <StatusItemMenu
              orderId={order?.id}
              handleUpdateStatus={handleUpdateStatus}
              status={'cancel'}
              icon='ri-close-circle-line'
              label='Annuler cette commande'
            />
          ) : (
            order?.status === 'cancel' && (
              <DeletedItemMenu orderId={order?.id} handleDelete={handleDelete} />
            )
          )}
        </Dropdown.Menu>
      </Dropdown>
    )
}